<template>
    <div class="register">
      <div class="register-main">
          <div style="cursor: pointer;" class="register-logo">
            <img @click="pageCut('/home')" src="@/assets/login/new-login-logo.png" alt="">
          </div>

          <div class="register-content">
              <h1>普通用户注册</h1>

              <el-form class="demo-dynamic"
                label-width="150px"
                label-position='left'
                ref="form"
                :rules="rules"
                :model="form">
                <el-form-item label="手机号：" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>

                <el-form-item label="密 码：" prop="password">
                  <el-input v-model="form.password" auto-complete="new-password" :type="oncePasswordType" placeholder="6-12位数字或字母或两者组合，区分大小写">
                     <i slot="suffix" class="el-input__icon el-icon-view" @click="changeType('once')"></i>
                  </el-input>
                </el-form-item>

                <el-form-item label="再次输入密码：" prop="rawPassword" >
                  <el-input v-model="form.rawPassword" auto-complete="new-password" :type="twicePasswordType" placeholder="再次输入密码">
                      <i slot="suffix" class="el-input__icon el-icon-view" @click="changeType('twice')"></i>
                  </el-input>
                </el-form-item>

                <el-form-item label="识别码：" prop="headingCode">
                  <el-input v-model="form.headingCode" placeholder="请输入识别码"></el-input>
                   <div class="heading-code-box" @click="getHeadingCode">
                    <img :src="headingCodeImg" alt="">
                  </div>
                  <span class="change-codeImg" @click="getHeadingCode">看不清？换一张</span>
                </el-form-item>

                <el-form-item label="短信验证码：" prop="verificationCode">
                  <el-input v-model="form.verificationCode" placeholder="请输入短信验证码"></el-input>
                  <div class="verification-code-box"
                    @click="sendingFlag && getVerificationCode()"
                    :disabled="disabledFlag">
                    <el-button :disabled="disabledFlag" v-if="sendingFlag">获取验证码</el-button>
                    <el-button :disabled="disabledFlag" v-else>{{codeTime}}</el-button>
                  </div>
                </el-form-item>

                <div class="register-btn" @click="onRegister('common')">注 册</div>
                <br>
                <el-checkbox class="form-styles" v-model="agreement">我已阅读并同意
                  <span class="user-agreement" @click="goAgreement()">《联盟官网用户协议》</span>
                </el-checkbox>
              </el-form>

              <p class="skip-link" @click="login" style="cursor: pointer;">立即登录> </p>
          </div>
      </div>
    </div>
</template>

<script>
import mixins from '@/utils/mixin'
export default {
  name: 'register',
  mixins: [mixins],
  props: {

  },
  components: {

  },
  data () {
    // 确认密码逻辑
    var coaffirmPassword = (rule, value, callback) => {
      if (this.form.rawPassword === '') { return callback(new Error('请再次输入密码')) }
      if (this.form.password !== this.form.rawPassword) {
        return callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      oncePasswordType: 'password', // 密码类型
      twicePasswordType: 'password', // 密码类型
      form: {
        phone: '', // 手机号
        password: '', // 密码
        rawPassword: '', // 密码确认
        headingCode: '', // 识别码
        verificationCode: '' // 验证码
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^[0-9A-Za-z]{6,12}$/, message: '密码格式为6-12位数字或字母或两者组合，区分大小写', trigger: 'blur' }
        ],
        rawPassword: [
          { required: true, validator: coaffirmPassword, trigger: 'blur' }
        ],
        headingCode: [
          { required: true, message: '请输入识别码', trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      headingCodeImg: '', // 识别码图片
      uuid: '', // 用户识别id
      phoneCode: '', // 手机验证码
      agreement: false, // 用户协议
      disabledFlag: false, // 获取验证码按钮状态
      codeTime: 60, // 验证码倒计时
      sendingFlag: true // 发送验证码状态
    }
  },
  computed: {

  },
  created () {
    this.getHeadingCode()
  },
  mounted () {

  },
  methods: {
    // 密码显示切换
    changeType (val) {
      if (this.oncePasswordType === 'password' && val === 'once') {
        this.oncePasswordType = 'text'
      } else {
        this.oncePasswordType = 'password'
      }

      if (this.twicePasswordType === 'password' && val === 'twice') {
        this.twicePasswordType = 'text'
      } else {
        this.twicePasswordType = 'password'
      }
    },

    // 跳转登录页面
    login () {
      this.$router.push('/login')
    },
    pageCut (path) {
      this.$router.push(path)
    },
    // 获取识别码
    async getHeadingCode () {
      try {
        const res = await this.$get(this.$url.login.getHeadingCode)
        const { code, msg, data } = res.data
        if (code === 200) {
          this.uuid = data.uuid
          this.headingCodeImg = data.img
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取验证码
    async getVerificationCode () {
      try {
        if (!this.checkUserPhone(this.form.phone)) { return false }
        const res = await this.$get(this.$url.login.getVerificationCode + this.form.phone)
        const { code, msg } = res.data
        if (code === 200) {
          this.disabledFlag = true
          this.codeTimer()
          this.phoneCode = msg
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 验证码倒计时
    codeTimer () {
      if (this.codeTime > 0) {
        this.codeTime--
        this.sendingFlag = false
        setTimeout(() => { this.codeTimer() }, 1000)
      } else {
        this.codeTime = 60
        this.sendingFlag = true
        this.disabledFlag = false
      }
    },
    // 注册
    async onRegister (type) {
      try {
        var reg = /^[0-9A-Za-z]{6,12}$/
        if (this.form.phone === '') { this.$message.error('请填写手机号！'); return false }
        if (this.form.password === '') { this.$message.error('请填写密码！'); return false }
        if (reg.test(this.form.password) === false) { this.$message.error('请正确填写密码！'); return false }
        if (this.form.rawPassword === '') { this.$message.error('请确认密码！'); return false }
        if (this.form.rawPassword !== this.form.password) { this.$message.error('两次填写密码不一致！'); return false }
        if (this.agreement === false) { this.$message.error('请勾选用户协议后注册！'); return false }

        const res = await this.$post(this.$url.login.commonRegister, {
          code: this.form.headingCode,
          passWord: this.form.rawPassword,
          phoneCode: this.form.verificationCode,
          userName: this.form.phone,
          uuid: this.uuid
        })
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          sessionStorage.setItem('tokenStr', data.token) // 临时保存token
          sessionStorage.setItem('userType', type) // 保存用户类型
          this.$router.push('/login')
          this.$message.success('注册成功！')
        } else {
          this.getHeadingCode()
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 跳转联盟用户协议页
    goAgreement () {
      this.$router.push('/userAgreement')
    }
  }
}
</script>

<style scoped lang="less">
.register{
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background:url('~@/assets/login/login-bg.jpg') no-repeat ;
  background-size: cover;
}
.register-main{
  display: flex;
  width: 1200px;
  height: 628px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.register-logo{
  width: 484px;
  height: 628px;
}
.register-content{
  position: relative;
  width: 100%;
  height: 628px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 8px 8px 0;
  h1{
    font-size: 30px;
    font-weight: 600;
  }

  .demo-dynamic{
    position: relative;
    font-size: 14px;
    margin-top: 32px;
  }
  .change-codeImg{
    position: absolute;
    top: -5px;
    right: -95px;
    z-index: 10;
    font-size: 12px;
    color: #3056D9;
    cursor: pointer;
  }
  .heading-code-box{
    position: absolute;
    top: -10px;
    right: 0;
    z-index: 10;
    width: 114px;
    height: 36px;
    border: 1px solid #ccc;
    border-radius: 2px;
    img{
      width: 114px;
      height: 36px;
    }
  }
  .verification-code-box{
    position: absolute;
    top: -10px;
    right: 0;
    z-index: 10;
    width: 114px;
    height: 36px;
    line-height: 36px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    /deep/.el-button{
      background: #1076EC;
      color: #fff;
      width: 110px;
    }
    /deep/.is-disabled{
      background: #D3D3D3;
    }
  }

  .register-btn{
    width: 400px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border: 1px solid #3056D9;
    background-color: #3056D9;
    color: #fff;
    margin-top: 18px;
  }
  .form-styles{
    margin: 14px 0 44px;
    align-items: left;
    .user-agreement{
      text-decoration: underline;
    }
  }

  .skip-link{
    position: absolute;
    bottom: 24px;
    right: 30px;
    font-size: 14px;
    text-decoration: underline;
  }
}

/deep/.el-form-item__label{
  border-bottom: 1px solid #BCBFC6;
  font-size: 14px;
  color: #000;
}
/deep/.el-input__inner{
  width: 290px;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #BCBFC6;
  margin-top: 1px;
  padding: 0;
  font-size: 14px;
  color: #000;
}
</style>
